// src/components/Loader.js
const Loader = ({ text = "Loading..." }) => (
  <div style={{ textAlign: 'center', padding: '2rem' }}>
    <div className="spinner"></div>
    <div>{text}</div>
  </div>
);

export default Loader;